import { Box, Button, Grid, Typography } from "@mui/material";
import { useState } from "react";
import { toast } from "react-toastify";
import { changeStatus, deleteUser, generateTempCode } from "../../api/admins";
import {
  changeStatusGroupLeader,
  generateTempCodeForGroup,
  removeFromGroup,
} from "../../api/group";
import AccessibilityIcon from "../../assets/SVG/accessibilityIcon";
import CloseIcon from "../../assets/SVG/closeIcon";
import DeleteIcon from "../../assets/SVG/deleteIcon";
import EyeIcon from "../../assets/SVG/eyeIcon";

export default function SelectionFuncTable({
  count,
  data,
  refetchData,
  selected,
  onClose,
}) {
  const [showRemoveConfirmation, setShowRemoveConfirmation] = useState(false);

  return (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <Box
        sx={{ boxShadow: "0px 4px 15px 0px rgba(0, 0, 0, 0.25)" }}
        bgcolor="#9091A6"
        width="65%"
        height="60px"
        borderRadius="30px"
        position={"fixed"}
        bottom="20px"
        display="flex"
        justifyContent={"space-between"}
        alignItems="center"
      >
        {!showRemoveConfirmation && (
          <>
            <Box display="flex" alignItems="center" mr="20px" gap="20px">
              <Grid style={{ cursor: "pointer" }} onClick={onClose}>
                <CloseIcon size="1.8" color="white" />
              </Grid>
              <Typography
                fontFamily={"Vazirmatn"}
                color="white"
                fontSize="18px"
              >{`${count} مورد انتخاب شده`}</Typography>
            </Box>
            <Box display="flex">
              {count === 1 && (
                <>
                  <Box
                    bgcolor="#676995"
                    width="190px"
                    height="40px"
                    borderRadius="10px"
                    display="flex"
                    alignItems={"center"}
                    justifyContent={"center"}
                    color="white"
                    marginInlineEnd={"20px"}
                    sx={{ cursor: "pointer" }}
                    gap="10px"
                    onClick={() => {
                      if (data?.length > 0) {
                        if (selected === 4) {
                          generateTempCodeForGroup(data[0]?.data.id)
                            .then((y) => {
                              navigator.clipboard.writeText(y);
                              toast.success("کد موقت کپی شد!");
                            })
                            .catch(() => {});
                          return;
                        }
                        generateTempCode(data[0]?.data.id)
                          .then((y) => {
                            navigator.clipboard.writeText(y);
                            toast.success("کد موقت کپی شد!");
                          })
                          .catch(() => {});
                      }
                    }}
                  >
                    <EyeIcon size="1.2" color="white" />
                    {selected !== 2 ? "مشاهده صفحه جهادگر" : "مشاهده صفحه گروه"}
                  </Box>
                  <Box
                    bgcolor={
                      data[0]?.data?.status === "PENDING"
                        ? "#682C54"
                        : "#F05542"
                    }
                    width="150px"
                    height="40px"
                    borderRadius="10px"
                    display="flex"
                    alignItems={"center"}
                    justifyContent={"center"}
                    color="white"
                    marginInlineEnd={"20px"}
                    sx={{ cursor: "pointer" }}
                    gap="10px"
                    onClick={() => {
                      if (selected === 1) {
                        changeStatus(
                          data[0].data.id,
                          data[0].data.status.toUpperCase() === "PENDING"
                            ? "ACTIVE"
                            : "PENDING",
                        )
                          .then(() => refetchData())
                          .catch(() => {});
                      }
                      if (selected === 2) {
                        changeStatus(
                          data[0].data.id,
                          data[0].data.status.toUpperCase() === "PENDING"
                            ? "ACTIVE"
                            : "PENDING",
                        )
                          .then(() => refetchData())
                          .catch(() => {});
                      }
                      if (selected === 3) {
                        changeStatus(
                          data[0].data.id,
                          data[0].data.status.toUpperCase() === "PENDING"
                            ? "ACTIVE"
                            : "PENDING",
                        )
                          .then(() => refetchData())
                          .catch(() => {});
                      }
                      if (selected === 4) {
                        changeStatusGroupLeader(
                          data[0].data.id,
                          data[0].data.status.toUpperCase() === "PENDING"
                            ? "ACTIVE"
                            : "PENDING",
                        )
                          .then(() => refetchData())
                          .catch(() => {});
                      }
                    }}
                  >
                    <AccessibilityIcon size="1" color="white" />
                    {selected === 1
                      ? data[0]?.data?.status.toUpperCase() === "PENDING"
                        ? "اجازه دسترسی"
                        : "لغو دسترسی"
                      : data[0]?.data?.status.toUpperCase() === "PENDING"
                        ? "اجازه دسترسی"
                        : "لغو دسترسی"}
                  </Box>
                </>
              )}

              <Box
                bgcolor="#E24B4B"
                width="150px"
                height="40px"
                borderRadius="10px"
                display="flex"
                alignItems={"center"}
                justifyContent={"center"}
                color="white"
                marginInlineEnd={"20px"}
                sx={{ cursor: "pointer" }}
                onClick={() => setShowRemoveConfirmation(true)}
              >
                <DeleteIcon color="white" />
                {selected !== 2 ? "حذف جهادگران" : "حذف گروه"}
              </Box>
            </Box>
          </>
        )}
        {showRemoveConfirmation && (
          <Grid
            display={"flex"}
            mx={"20px"}
            justifyContent={"space-between"}
            width={"100%"}
          >
            <Box display="flex" alignItems="center" gap="20px">
              <Grid
                style={{ cursor: "pointer" }}
                onClick={() => setShowRemoveConfirmation(false)}
              >
                <CloseIcon size="1.8" color="white" />
              </Grid>
              <Typography
                fontFamily={"Vazirmatn"}
                color="white"
                fontSize="18px"
              >
                آیا از حذف آیتم‌های انتخاب شده، اطمینان دارید؟
              </Typography>
            </Box>
            <Grid display={"flex"} flexDirection={"row"} gap={"20px"}>
              <Button
                sx={{ fontFamily: "Vazirmatn" }}
                onClick={() => {
                  data.forEach((x) => {
                    if (selected === 4) {
                      removeFromGroup(x.data.id)
                        .then(() => refetchData())
                        .catch(() => {});
                    } else {
                      deleteUser(x.data.id)
                        .then(() => refetchData())
                        .catch(() => {});
                    }
                  });
                }}
                variant="outlined"
              >
                بله
              </Button>
              <Button
                sx={{ fontFamily: "Vazirmatn" }}
                onClick={() => setShowRemoveConfirmation(false)}
                variant="contained"
                color="error"
              >
                خیر
              </Button>
            </Grid>
          </Grid>
        )}
      </Box>
    </Box>
  );
}
